import { LOGIN_PATH } from 'constants/navigation';
import { getCurrentUrl } from 'utils/window';

class SocialNetworks {
  authServiceUrl: any;

  location: any;

  constructor(authServiceUrl: any) {
    this.authServiceUrl = authServiceUrl;
    this.location = `${getCurrentUrl()}#${LOGIN_PATH}`;
  }

  getAuthLink(socialNetworkName: string) {
    const isIframe = window.top !== window.self;
    const isMainHost = window.location.host.indexOf('easygenerator.com') !== -1;

    const encodedLocation = encodeURIComponent(this.location);
    const addTokenQueryParam = isIframe || !isMainHost ? '&addTokenQuery=true' : '';

    return `${this.authServiceUrl}/api/auth/${socialNetworkName}?callbackUrl=${encodedLocation}${addTokenQueryParam}`;
  }
}

export default SocialNetworks;
